/**
 * @generated SignedSource<<1572ce0446a2e9cccf843d977e760152>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous =
  {
    __typename?: "Anonymous";
    permissionType: SitePermissionType | null;
  };
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    permissionType: SitePermissionType | null;
  };
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser =
  {
    __typename?: "UnknownUser";
    accountId: string | null;
    permissionType: SitePermissionType | null;
  };
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_User =
  {
    __typename?: "User";
    permissionType: SitePermissionType | null;
  };
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes =

    | FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous
    | FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser
    | FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser
    | FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes_User;
export type FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList =
  {
    __typename?: "PaginatedPersonList";
    nodes: Array<FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList_nodes | null> | null;
  };
export type FetchPresenceUsersGuestStatusQuery_Query = {
  __typename?: "Query";
  confluenceUsers: FetchPresenceUsersGuestStatusQuery_confluenceUsers_PaginatedPersonList | null;
};
export type FetchPresenceUsersGuestStatusQueryVariables = Exact<{
  accountIds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;
export type FetchPresenceUsersGuestStatusQuery =
  FetchPresenceUsersGuestStatusQuery_Query;
